import axios from 'axios'
import { $t } from '@/i18n'

const http = axios.create({
  baseURL: '/hf',
  timeout: 21000,
  headers: {
    'Content-Type': 'application/json',
  },
})
let loading = null
// 请求拦截器
http.interceptors.request.use(
  (config) => {
    const { $createToast } = window.HM
    if (config?.fullscreenLoading && $createToast) {
      loading = $createToast({
        time: 0,
      })
      loading.show()
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

// 响应拦截器
http.interceptors.response.use(
  (response) => {
    const { data, config = {} } = response
    loading?.hide()
    if (config.responseType === 'blob') {
      // blob数据无需处理
      return data
    }
    // 如果有错误码 进入错误码统一处理流程
    if (data.errorCode && data.errorCode !== '0') {
      // 没有设置hasHandleError为true的话 走catch
      if (!config.hasHandleError) {
        const { $createToast } = window.HM || {}
        $createToast &&
          $createToast({
            txt: $t(data.errorCode),
            type: 'error',
            time: 1500,
          }).show()
        throw data
      }
      // 配置了错误处理函数就走错误处理
      if (typeof config.onError === 'function') {
        config.onError(data)
      }
    }
    return data
  },
  async (error) => {
    loading?.hide()
    let txt = $t('hf_web_request_fail_status_msg')
    // 其他请求错误码
    if (error.response) {
      switch (error.response.status) {
        case 401:
          txt = $t('hf_web_auth_fail_msg')
          break
        case 500:
          txt = $t('hf_web_server_error_msg')
          break
        default:
          txt = $t('hf_web_request_fail_status_msg') + error.response.status
      }
    }
    if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
      txt = $t('hf_web_request_timeout_msg')
    }
    const { $createToast } = window.HM || {}
    $createToast &&
      $createToast({
        txt,
        type: 'error',
        time: 1500,
      }).show()
    return Promise.reject(error)
  },
)

export default {
  get(url, config = {}) {
    return http.get(url, config)
  },
  post(url, data = {}, config) {
    return http.post(url, data, config)
  },
  put(url, data = {}, config) {
    return http.put(url, data, config)
  },
  delete(url, config = {}) {
    return http.delete(url, config)
  },
}
